<template>
  <div>
    <common-table
        :table-columns="tableColumns"
        :url="url"
        :operate="[]"
        :searchs="searchs"
        :form-fields="formFields"
        :permission="permission"
    />
  </div>
</template>

<script>
import CommonTable from "@/components/CommonTable/CommonTable.vue";

export default {
  name: 'MultiPlanCategoryRoi',
  components: { CommonTable },
  data() {
    return {
      searchs: [{
        name: 'agentId',
        placeholder: '代理',
        type: 'select',
        selectUrl: '/agent/getAll',
        selectData: [],
      }],
      permission: {
        add: 'multiPlanCategoryRoi:add',
        update: 'multiPlanCategoryRoi:update',
        delete: 'multiPlanCategoryRoi:delete',
        deleteBatch: 'multiPlanCategoryRoi:deleteBatch'
      },
      url: {
        get: '/multiPlanCategoryRoi/listByCondition',
        add: '/multiPlanCategoryRoi/add',
        update: '/multiPlanCategoryRoi/update',
        delete: '/multiPlanCategoryRoi/delete',
        delete_batch: '/multiPlanCategoryRoi/deleteBatch',
        status: '/multiPlanCategoryRoi/status',
      },
      tableColumns: [
        {
          field: 'id',
          label: 'Id',
          show: true,
          width: '100',
        },
        {
          field: 'agentId',
          label: '代理',
          selectUrl: '/agent/getAll',
          selectData: [],
          show: {
            type: 'select',
          },
        },
        {
          field: 'categoryName',
          label: '类别名称',
          sort: false,
          show: true,
        },
        {
          field: 'productCount',
          label: '类别分组数量',
          sort: false,
          show: true,
        },
        {
          field: 'minCommissionRate',
          label: '最小佣金率',
          sort: false,
          show: true,
        },
        {
          field: 'maxCommissionRate',
          label: '最大佣金率',
          sort: false,
          show: true,
        },
        {
          field: 'minCommission',
          label: 'ROI',
          sort: false,
          show: true,
        },
        {
          field: 'createTime',
          label: '时间',
          show: true,
        }
      ],
      formFields: {
        addTitle: '添加',
        updateTitle: '修改',
        labelWidth: '110px',
        addGuide: {
          title: '多品计划类别 ROI 说明',
          summary: '这张表单用于按「商品数量 + 佣金率区间」配置 ROI。多品定时任务会据此为不同类别商品匹配投放 ROI。',
          icon: 'el-icon-s-grid',
          points: [
            '类别名称建议用业务可读名称，例如「低佣爆款组」。',
            '商品数量表示该类别一次投放包含的商品个数，最大 30。',
            '最小/最大佣金率需覆盖完整区间，ROI 为该区间统一使用的目标值。'
          ]
        },
        model: [
          {
            field: 'agentId',
            label: '代理：',
            type: 'select',
            placeholder: '请选择代理',
            rules: [{ required: true, message: '请选择代理', trigger: 'blur' }],
            selectUrl: '/agent/getAll',
            selectData: [],
            add: true,
            update: true,
            filterable: true,
          },
          {
            field: 'categoryName',
            label: '类别名称',
            type: 'input',
            placeholder: '请输入类别名称',
            rules: [
              { required: true, message: '类别名称不能为空', trigger: 'blur' }
            ],
            add: true,
            update: true,
          },
          {
            field: 'productCount',
            label: '商品数量',
            type: 'input',
            placeholder: '请输入商品数量',
            tip: '提示：单次投放包含的商品个数，须为 1～30 的整数。',
            rules: [
              {required: true, message: '商品数量不能为空', trigger: 'blur'},
              {
                validator(rule, value, callback) {
                  if (!/^\d+$/.test(value)) {
                    callback(new Error('商品数量必须为整数'));
                  } else if (parseInt(value) > 30) {
                    callback(new Error('商品数量最大为30'));
                  } else {
                    callback();
                  }
                },
                trigger: 'blur'
              }
            ],
            add: true,
            update: true,
          },
          {
            field: 'minCommissionRate',
            label: '最小佣金率',
            type: 'input',
            placeholder: '请输入最小佣金率',
            tip: '提示：佣金率区间下限，单位与业务配置一致，最多两位小数。',
            rules: [
              {required: true, message: '最小佣金率不能为空', trigger: 'blur'},
              {
                type: 'number',
                message: '最小佣金率必须为数字',
                transform(value) {
                  return value === '' ? NaN : Number(value);
                },
                trigger: 'blur'
              },
              {
                pattern: /^\d+(\.\d{1,2})?$/,
                message: '最小佣金率最多保留2位小数',
                trigger: 'blur'
              }
            ],
            add: true,
            update: true,
          },
          {
            field: 'maxCommissionRate',
            label: '最大佣金率',
            type: 'input',
            placeholder: '请输入最大佣金率',
            tip: '提示：应大于或等于最小佣金率，用于界定该类别的佣金率上限。',
            rules: [
              {required: true, message: '最大佣金率不能为空', trigger: 'blur'},
              {
                type: 'number',
                message: '最大佣金率必须为数字',
                transform(value) {
                  return value === '' ? NaN : Number(value);
                },
                trigger: 'blur'
              },
              {
                pattern: /^\d+(\.\d{1,2})?$/,
                message: '最大佣金率最多保留2位小数',
                trigger: 'blur'
              }
            ],
            add: true,
            update: true,
          },
          {
            field: 'minCommission',
            label: 'ROI',
            type: 'input',
            placeholder: '请输入ROI',
            tip: '提示：命中该类别（商品数 + 佣金率区间）时使用的目标 ROI。',
            rules: [
              {required: true, message: 'ROI不能为空', trigger: 'blur'},
              {
                type: 'number',
                message: 'ROI必须为数字',
                transform(value) {
                  return value === '' ? NaN : Number(value);
                },
                trigger: 'blur'
              },
              {
                pattern: /^\d+(\.\d{1,2})?$/,
                message: 'ROI最多保留2位小数',
                trigger: 'blur'
              }
            ],
            add: true,
            update: true,
          }
        ]
      },
      operate: []
    }
  }
}
</script>

<style scoped>

</style>
